<template>
  <button @change="$emit('input', $event.target.value)">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"
         style="display:inline-block;vertical-align:text-bottom">
      <path fill-rule="evenodd"
            d="M4.72 3.22a.75.75 0 011.06 1.06L2.06 8l3.72 3.72a.75.75 0 11-1.06 1.06L.47 8.53a.75.75 0 010-1.06l4.25-4.25zm6.56 0a.75.75 0 10-1.06 1.06L13.94 8l-3.72 3.72a.75.75 0 101.06 1.06l4.25-4.25a.75.75 0 000-1.06l-4.25-4.25z"></path>
    </svg>
    Edit Python
  </button>
</template>

<script>
export default {
  name: 'PythonButton'
}
</script>

<style lang="scss" scoped>
@use '../styles/variables' as v;

button {
  background-color: v.$gray2;
  border: none;
  border-radius: 2px;
  transition: background-color .2s ease-in-out;
  padding: 2px 8px;
  color: v.$white;

  &:hover {
    background-color: v.$gray3;
  }
}
</style>
